import React from "react";
import { userprofile } from "../../Model/Users"; //Include Home
import { Link } from "react-router-dom";
import { withRouter, VirsionCheck, Faq } from "../../Helpers/Common"; //Include Home
import { SVGIcons, ImgIcons } from "../../Helpers/Common";
import { Helmet, HelmetProvider } from "react-helmet";
import { motion } from "framer-motion";
import Parser from "html-react-parser";
import $ from "jquery";
import BarLoader from "react-spinners/BarLoader";
import { isMobile, isDesktop } from "react-device-detect";

import Profilemenu from "../Profile_menu/Profilemenu";

var SVGIcon = "";
SVGIcons().then((resultData) => (SVGIcon = resultData));

class TermsofuseMore extends React.Component {
  hideshow() {
    $(".temp3-item .temp3-head")
      .unbind()
      .click(function () {
        var activeTitle = $(this).hasClass("temp3Active");
        $(".temp3-item .temp3-head")
          .removeClass("temp3Active")
          .siblings(".temp3-content")
          .slideUp();
        if (!activeTitle) {
          $(this).addClass("temp3Active").next(".temp3-content").slideDown();
        }
      });
  }

  constructor(props) {
    super(props);
    this.state = {
      VirsionCheckData: [],
      VirsionCheckDataloaded: false,
      DataisLoaded: false,
      MoreFaq: false,
    };
  }

  componentDidMount() {
    //Get Virsion Check Data
    VirsionCheck().then((vcheckres) => {
      Faq('DocuBayFAQ', 100).then((FaqRes) => {
        if (FaqRes.data.body) {
          var Faqs = JSON.parse(FaqRes.data.body);
          this.setState({
            VirsionCheckData: vcheckres,
            VirsionCheckDataloaded: true,
            DataisLoaded: true,
            MoreFaq: Faqs.data
          });

        }
      })
    });
  }

  render() {

    return (
      <>
        <motion.div
          className=""
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1 }}
          key="1"
        >
          <main className="setting-main webviewpages">
            <section className="mb-0">
              <div className="temp47">
                <div className="temp47-inn temp47-asked-que">
                  <div className="temp3">
                    <div className="temp3-tabItem">
                      {this.state.MoreFaq.faq?.map((data, index) => {
                        return (
                          <div className="temp3-item">
                            <div
                              className="temp3-head"
                              onClick={() => {
                                this.hideshow();
                              }}
                            >
                              <p className="white">{data.question}</p>
                              <span className="temp3-headBtn">
                                <img src={SVGIcon["arrow-down.svg"]} />
                              </span>
                            </div>
                            <div className="temp3-content">
                              <p>{Parser(data.answer.split("<br />").join("\n"))}</p>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <div className="dD-block">
              <Profilemenu versioncheck={this.state.VirsionCheckData} profile={this.state.userData} />
            </div>
          </main>
        </motion.div>
      </>
    );
  }
}
export default withRouter(TermsofuseMore);
